import React, { useEffect, useState } from 'react'
import { useMutation } from '@apollo/client'
import { FormProvider, useForm } from 'react-hook-form'
import { toastSweetAlert } from '../../../Helpers/ToastSweetAlert'
import Box from '../../../Global/Box'
import Button from './Button'
import { GET_ALL_CONFIG_APP_PAGES } from '../../../../graphql/ConfigApp/configAppPages'
import {
  CREATE_OR_UPDATE_ELEMENT_ButtonsBox,
  GET_ALL_ELEMENTS_OF_CONFIG_APP_PAGE,
} from '../../../../graphql/ConfigApp/configAppPageElements'

const refetchConfigsAppPage = {
  query: GET_ALL_CONFIG_APP_PAGES,
  variables: {
    limit: 10,
    offset: 0,
    searchQuery: null,
  },
}

const ButtonsBox = ({ pageId, dataElement, setDataElement }) => {
  //SPACE
  const [items, setItems] = useState([])

  //MUTATIONS:
  const [createOrUpdate] = useMutation(CREATE_OR_UPDATE_ELEMENT_ButtonsBox)

  const {
    methods,
    handleSubmit,
    formState: { errors },
    control,
    reset,
  } = useForm()

  const handleCancel = () => setDataElement(null)

  const handleAddElement = () => setItems((old) => [...old, {}])

  const handleDeleteItem = ({ index }) => {
    const ajustItems = items.map((item, idx) => {
      if (idx === index) return { ...item, hide: true }
      return item
    })
    setItems(() => [...ajustItems])
  }

  const onSubmit = async (dataForm) => {
    try {
      let indexOk = []

      if (items.length === 0) throw new Error('Se debe enviar minimo un item s')

      items.map((item, index) => {
        if (item.hide === true) return false
        return indexOk.push(index)
      })

      if (indexOk.length === 0) throw new Error('Se debe enviar minimo un item')

      const itemsSend = []

      for await (const [index, item] of dataForm?.button.entries()) {
        if (indexOk.includes(index)) {
          if (item.text_es === '') {
            throw new Error(
              'Hay un Item que necesita capturarse el texto en español'
            )
          }

          itemsSend.push({
            layout: 'button',
            text: {
              es: item.text_es,
              en: item.text_en,
            },
            link: item.link,
            textColor: item.textColor,
            backgroundColor: item.backgroundColor,
            icon: {
              direction: item.icon_direction,
              fontawesome: item.icon_fontawesome,
              url: item.icon_url,
            },
          })
        }
      }

      if (itemsSend.length === 0)
        throw new Error('Se debe enviar minimo un item')

      let message = ''

      if (dataElement?.id) {
        //Es actualizacion
        const variables = {
          inputGeneral: {
            id: dataElement.id,
            config_app_page_id: dataElement.config_app_page_id,
            order: dataElement.order,
            layout: dataElement.layout,
          },
          inputElement: {
            items: itemsSend,
          },
        }
        await createOrUpdate({
          variables,
          refetchQueries: [
            {
              query: GET_ALL_ELEMENTS_OF_CONFIG_APP_PAGE,
              variables: { configAppPageId: pageId },
            },
          ],
        })
        message = 'Se actualizo correctamente'
      } else {
        //Es nuevo
        const variables = {
          inputGeneral: {
            id: null,
            config_app_page_id: dataElement.config_app_page_id,
            order: null,
            layout: dataElement.layout,
          },
          inputElement: {
            items: itemsSend,
          },
        }
        await createOrUpdate({
          variables,
          refetchQueries: [
            { ...refetchConfigsAppPage },
            {
              query: GET_ALL_ELEMENTS_OF_CONFIG_APP_PAGE,
              variables: { configAppPageId: pageId },
            },
          ],
        })
        message = 'Se creo con exito'
      }

      setDataElement(null)
      setItems([])

      return toastSweetAlert({ mode: 'ok', message })
    } catch (error) {
      return toastSweetAlert({
        mode: 'error',
        message: error.message,
      })
    }
  }

  useEffect(() => {
    if (dataElement?.id) {
      const data = dataElement
      const dataItems = data?.itemMain?.items

      let dataFormated = {}
      if (dataItems.length > 0) {
        dataItems.map((item, index) => {
          dataFormated = {
            ...dataFormated,
            [`button[${index}].text_es`]: item?.text?.es,
            [`button[${index}].text_en`]: item?.text?.en,
            [`button[${index}].link`]: item?.link,
            [`button[${index}].textColor`]: item?.textColor,
            [`button[${index}].backgroundColor`]: item?.backgroundColor,
            [`button[${index}].icon_direction`]: item?.icon?.direction,
            [`button[${index}].icon_fontawesome`]: item?.icon?.fontawesome,
            [`button[${index}].icon_url`]: item?.icon?.url,
          }
          return true
        })
      }

      reset(dataFormated)
      setItems(dataElement?.itemMain?.items)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataElement])

  return (
    <>
      <div className="row mb-4">
        <div className="col-12">
          <button
            className="btn btn-migrates"
            type="button"
            style={{ float: 'right' }}
            onClick={() => handleAddElement()}
          >
            <i className="fas fa-plus" />
            &nbsp;Agregar item
          </button>
        </div>
      </div>

      {items && items.length > 0 && (
        <FormProvider {...methods}>
          <form onSubmit={handleSubmit(onSubmit)}>
            <Box
              withCard={false}
              title="Elemento"
              btnSecondFunctionTitle="Cancelar"
              btnSubmitText={`${dataElement?.id ? 'Actualizar' : 'Crear'}`}
              btnSecondFunction={() => handleCancel()}
              errors={errors}
              btnSubmit={true}
              content={
                <>
                  {items &&
                    items.map((item, index) => {
                      return (
                        <div
                          className="mb-4"
                          key={index}
                          style={{ display: item?.hide === true ? 'none' : '' }}
                        >
                          <Button
                            index={index}
                            control={control}
                            handleDeleteItem={handleDeleteItem}
                          />
                        </div>
                      )
                    })}
                </>
              }
            />
          </form>
        </FormProvider>
      )}
    </>
  )
}

export default ButtonsBox
